import { ENV } from "../utils";

export class Auth {
  baseApi = ENV.BASE_API;

  async register(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REGISTER}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
        }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async login(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LOGIN}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async verifyEmailCode(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.VERIFY_2FA_EMAIL_CODE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async resendCode(data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.RESEND_2FA_CODE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async refreshAccessToken(refreshToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.REFRESH_ACCESS_TOKEN}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: refreshToken,
        }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async switchSite(accessToken, site) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SWITCH_SITE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ site }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  // "Mantener sesión iniciada" (checkbox de login): remember=true persiste
  // los tokens en localStorage (sobrevive a cerrar el navegador); remember=false
  // los guarda en sessionStorage (se pierden al cerrar la pestaña/navegador).
  setAccessToken(token, remember = true) {
    const storage = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    storage.setItem(ENV.JWT.ACCESS, token);
    other.removeItem(ENV.JWT.ACCESS);
  }

  getAccessToken() {
    return localStorage.getItem(ENV.JWT.ACCESS) || sessionStorage.getItem(ENV.JWT.ACCESS);
  }

  setRefreshToken(token, remember = true) {
    const storage = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    storage.setItem(ENV.JWT.REFRESH, token);
    other.removeItem(ENV.JWT.REFRESH);
  }

  getRefreshToken() {
    return localStorage.getItem(ENV.JWT.REFRESH) || sessionStorage.getItem(ENV.JWT.REFRESH);
  }

  // true si la sesión activa se guardó para persistir (localStorage) en vez
  // de solo para la pestaña actual (sessionStorage).
  isRemembered() {
    return (
      localStorage.getItem(ENV.JWT.ACCESS) !== null ||
      localStorage.getItem(ENV.JWT.REFRESH) !== null
    );
  }

  removeTokens() {
    for (const storage of [localStorage, sessionStorage]) {
      storage.removeItem(ENV.JWT.ACCESS);
      storage.removeItem(ENV.JWT.REFRESH);
    }
    localStorage.removeItem("site");
    localStorage.removeItem("company");
  }
}